import { GQL_ID } from '@@partner:types:graphql'

import type { Shop, GeoPoint, ShopBox, ShopImage } from '@@partner:types:app'

import { gql, useMutation } from '@apollo/client'

export interface ShopInfoInput {
  name: string
  address: string
  phone: string
  shopGeoPoint: GeoPoint
  status: number
  minOrderCost: number
  shopOpenTime?: number
  shopCloseTime?: number

  deliveryBoxes: Omit<ShopBox, 'id'>[]
  deliveryDefaultPickupComment: string

  images: Omit<ShopImage, 'url'>[]

  shopTags: GQL_ID[]

}

export interface UpdateShopInfo {
  shopInfo: Shop
}

export interface UpdateShopInfoVariables {
  shop_id?: GQL_ID
  shopInfo?: ShopInfoInput
  upsert?: boolean
}

export const GQL_MUTATION_UPDATE_SHOP_INFO = gql`
  mutation (
    $shop_id: ID, 
    $shopInfo: ShopInfoInput!,
    $upsert: Boolean
    ) {
    shopInfo: updateShopInfo(shop_id: $shop_id, shopInfo: $shopInfo, upsert: $upsert) {
      id
      xid
      slug
      name
      status
      
      workingHours
      tzOffset
      address
      phone


      minOrderCost
      pickup_delivery_cost
      has_pickup_delivery_enabled
      
      shopGeoPoint {
        latitude
        longitude
      }
      shopOpenTime
      shopCloseTime
      
      tg_chat_id
      vkMaxChatId

      slotPlans {
        id
        shop_id
        weekDay
        slotStartTime
        slotFinishTime
        ordersLimit
        positionsLimit
        slotTimeout
      }

      deliveryBoxes {
        id
        name
        number
        shop_id
        sort_order
        special_conditions
      }

      shopTags {
        id
        name
      }

      is_serving_wholesale
      is_serving_retail

      deliveryDefaultPickupComment

      images {
        url
        weight
      }
    }
  }
`

export const useUpdateShopInfo = (shop_id: GQL_ID) => {
  return useMutation<UpdateShopInfo, UpdateShopInfoVariables>(
    GQL_MUTATION_UPDATE_SHOP_INFO,
    {
      variables: {
        shop_id
      }
    }
  )
}
